import ApiService from "@/services/api.service";

const downloadRankingXlsx = async (id) => {
  try {
    const response = await ApiService.get(`dealer-incentives/${id}/ranking/xlsx`, {
      responseType: "blob",
    });

    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  downloadRankingXlsx,
};
